module.exports = __webpack_public_path__ + "static/media/heroku.5f6ba6aa.png";